<div class="contenedorDetalle">
  <div class="detalleHeader">
    <h2>Detalle Centro Productor: {{ centro?.nombre }}</h2>
    <div *ngIf="
        path !== '/cliente/centros'
      ">
      <button (click)="disableInput()" *ngIf="role != 'user'">Editar</button>
    </div>
    <!-- <button class="button__secondary">Imprimir</button>
    <button class="button__secondary">Descarga</button> -->
  </div>
  <div>
    <form novalidate [formGroup]="detalleCentro" class="detalleContenido">
      <h3>Datos del Centro</h3>
      <div class="datos__detalle">
        <div>
          <label for="nombre">Denominación</label>
          <input [attr.disabled]="disableInputBox ? true : null" type="text" formControlName="nombre" id="nombre" />
        </div>
        <div>
          <label for="nima">NIMA</label>
          <input [attr.disabled]="disableInputBox ? true : null" type="text" formControlName="nima" id="nima" />
        </div>
      </div>
      <div formGroupName="direccion" class="displayFlex">
        <label for="direccion">Dirección</label>

        <input [attr.disabled]="disableInputBox ? true : null" type="text" formControlName="via" id="via" />
        <input [attr.disabled]="disableInputBox ? true : null" type="text" formControlName="nombre" id="nombreVia" />
        <input [attr.disabled]="disableInputBox ? true : null" type="text" formControlName="numero" id="numero" />

        <input [attr.disabled]="disableInputBox ? true : null" type="text" formControlName="provincia" id="provincia" />
        <input [attr.disabled]="disableInputBox ? true : null" type="text" formControlName="ccaa" id="ccaa" />

        <input [attr.disabled]="disableInputBox ? true : null" type="text" formControlName="cp" id="cp" />
      </div>
      <div class="displayFlex">
        <label for="contratista">Contratista</label>
        <span *ngIf="centro?.contratista?.nombreComercial">
          {{ centro?.contratista?.nombreComercial }}
        </span>
      </div>

      <div class="displayFlex">
        <div class="displayFlex residuos">
          <label for="resPeligrosos">Productor de Residuos Peligrosos</label>
          <span *ngIf="centro?.resPeligrosos === true" class="color-primary">
            Sí
          </span>
          <span *ngIf="centro?.resPeligrosos === false" class="color-primary">
            No
          </span>
        </div>
        <div class="displayFlex residuos">
          <label for="resPeligrososGrande">
            Gran Productor de <br>Residuos NO Peligrosos
          </label>
          <span *ngIf="centro?.GPResPeligrosos === true" class="color-primary">
            Sí
          </span>
          <span *ngIf="centro?.GPResPeligrosos === false" class="color-primary">
            No
          </span>
        </div>
      </div>

      <div formGroupName="contacto">
        <h3>Datos de contacto</h3>
        <div class="datos__detalle">
          <div>
            <label for="contactoNombre">Persona de Contacto</label>
            <input [attr.disabled]="disableInputBox ? true : null" type="text" formControlName="contactoNombre"
              id="contactoNombre" />
          </div>
          <div>
            <label for="contactoMail">Mail de Contacto</label>
            <input [attr.disabled]="disableInputBox ? true : null" type="text" formControlName="contactoMail"
              id="contactoMail" />
          </div>
        </div>
      </div>
      <div *ngIf="!disableInputBox">
        <button (click)="UpdateCentroById()">Guardar</button>
      </div>
    </form>
    <div *ngIf="path === '/cliente/centros'">
      <h3>Documentos Obligatorios del Centro</h3>
      <div class="displayFlex documentos">
        <div class="displayFlexVertical" *ngFor="let documento of documentosVista">
          <div *ngIf="!documento.validado">
            <img (click)="openDocumento(documento.id)" src="../../../../../assets/pendiente-de-validar.svg" />
          </div>
          <div *ngIf="documento.enFecha && documento.tipo === 'activo'">
            <img (click)="openDocumento(documento.id)" src="../../../../../../assets/validado.svg" #tooltip="matTooltip"
              matTooltip="Validado" matTooltipPosition="left" />
          </div>
          <div *ngIf="documento.proximoCaduca && documento.tipo === 'activo'">
            <img (click)="openDocumento(documento.id)" src="../../../../../assets/proximo-a-caducar.svg"
              #tooltip="matTooltip" matTooltip="Próximo a caducar" matTooltipPosition="left" />
          </div>
          <div *ngIf="documento.caducado && documento.tipo === 'activo'">
            <img (click)="openDocumento(documento.id)" src="../../../../../assets/caducado.svg" #tooltip="matTooltip"
              matTooltip="Caducado" matTooltipPosition="left" />
          </div>
          <div *ngIf="documento.enFecha && documento.tipo === 'enEspera'" class="paper">
            <img (click)="openDocumento(documento.id)" src="../../../../../assets/verde.png" #tooltip="matTooltip"
              matTooltip="Documento nuevo rechazado" matTooltipPosition="left" />
          </div>
          <div *ngIf="documento.caducado && documento.tipo === 'enEspera'" class="paper">
            <img (click)="openDocumento(documento.id)" src="../../../../../assets/rojo.png" #tooltip="matTooltip"
              matTooltip="Documento nuevo rechazado" matTooltipPosition="left" />
          </div>
          <div *ngIf="documento.proximoCaduca && documento.tipo === 'enEspera'" class="paper">
            <img class="documento__circulo" (click)="openDocumento(documento.id)"
              src="../../../../../assets/Amarillo.png" #tooltip="matTooltip" matTooltip="Documento nuevo rechazado"
              matTooltipPosition="left" />
          </div>
          <p>{{documento.nombre}}</p>
          <p style="background-color: #1F775A; color: white; border-radius: 4px; padding: 0 0.2rem 0 0.2rem;">
            {{documento.nombreArchivo}}</p>
          <p>{{documento?.fechaValidez | date: 'dd/MM/yyyy'}}</p>
          <div *ngIf="documento.fechaCaducidad">
            <p>{{documento?.fechaCaducidad | date: 'dd/MM/yyyy'}}</p>
          </div>
          <div *ngIf="!documento.fechaCaducidad">
            <p>No caduca</p>
          </div>
        </div>
      </div>
      <h3>Documentos Adicionales del Centro</h3>
      <div class="displayFlex documentosAdic">
        <div class="displayFlexVertical" *ngFor="let documento of documentosAdicVista">
          <div *ngIf="documento.fechaValidez && !documento.firsTime || documento.noCaduca && !documento.firsTime ">
            <div *ngIf="!documento.validado">
              <img (click)="openDocumentoAdic(documento.id)" src="../../../../../assets/pendiente-de-validar.svg" />
            </div>
            <div *ngIf="documento.enFecha && documento.tipo === 'activo'">
              <img (click)="openDocumentoAdic(documento.id)" src="../../../../../../assets/validado.svg"
                #tooltip="matTooltip" matTooltip="Validado" matTooltipPosition="left" />
            </div>
            <div *ngIf="documento.proximoCaduca && documento.tipo === 'activo'">
              <img (click)="openDocumentoAdic(documento.id)" src="../../../../../assets/proximo-a-caducar.svg"
                #tooltip="matTooltip" matTooltip="Próximo a caducar" matTooltipPosition="left" />
            </div>
            <div *ngIf="documento.caducado && documento.tipo === 'activo'">
              <img (click)="openDocumentoAdic(documento.id)" src="../../../../../assets/caducado.svg"
                #tooltip="matTooltip" matTooltip="Caducado" matTooltipPosition="left" />
            </div>
            <div *ngIf="documento.enFecha && documento.tipo === 'enEspera'" class="paper">
              <img (click)="openDocumentoAdic(documento.id)" src="../../../../../assets/verde.png" #tooltip="matTooltip"
                matTooltip="Documento nuevo rechazado" matTooltipPosition="left" />
            </div>
            <div *ngIf="documento.caducado && documento.tipo === 'enEspera'" class="paper">
              <img (click)="openDocumentoAdic(documento.id)" src="../../../../../assets/rojo.png" #tooltip="matTooltip"
                matTooltip="Documento nuevo rechazado" matTooltipPosition="left" />
            </div>
            <div *ngIf="documento.proximoCaduca && documento.tipo === 'enEspera'" class="paper">
              <img class="documento__circulo" (click)="openDocumentoAdic(documento.id)"
                src="../../../../../assets/Amarillo.png" #tooltip="matTooltip" matTooltip="Documento nuevo rechazado"
                matTooltipPosition="left" />
            </div>
            <p>{{documento.nombre}}</p>
            <p style="background-color: #1F775A; color: white; border-radius: 4px; padding: 0 0.2rem 0 0.2rem;">
              {{documento.nombreArchivo}}</p>
            <p>{{documento?.fechaValidez | date: 'dd/MM/yyyy'}}</p>
            <div *ngIf="documento.fechaCaducidad">
              <p>{{documento?.fechaCaducidad | date: 'dd/MM/yyyy'}}</p>
            </div>
            <div *ngIf="!documento.fechaCaducidad">
              <p>No caduca</p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div *ngIf="path === '/contratista/estado/centros'">
      <h3>Documentos Obligatorios del Centro</h3>
      <div class="displayFlex documentos">
        <div class="displayFlexVertical" *ngFor="let documento of documentosVista">
          <div *ngIf="!documento.validado">
            <img (click)="openDocumento(documento.id)" src="../../../../../assets/pendiente-de-validar.svg" />
          </div>
          <div *ngIf="(documento.enFecha || documento.noCaduca) && documento.tipo === 'activo'">
            <img (click)="openDocumento(documento.id)" src="../../../../../assets/validado.svg" #tooltip="matTooltip"
              matTooltip="Validado" matTooltipPosition="left" />
          </div>
          <div *ngIf="documento.proximoCaduca && documento.tipo === 'activo'">
            <img (click)="openDocumento(documento.id)" src="../../../../../assets/proximo-a-caducar.svg"
              #tooltip="matTooltip" matTooltip="Próximo a caducar" matTooltipPosition="left" />
          </div>
          <div *ngIf="documento.caducado && documento.tipo === 'activo'">
            <img (click)="openDocumento(documento.id)" src="../../../../../assets/caducado.svg" #tooltip="matTooltip"
              matTooltip="Caducado" matTooltipPosition="left" />
          </div>
          <div *ngIf="documento.enFecha && documento.tipo === 'enEspera'" class="paper">
            <img (click)="openDocumento(documento.id)" src="../../../../../assets/verde.png" #tooltip="matTooltip"
              matTooltip="Documento nuevo rechazado" matTooltipPosition="left" />
          </div>
          <div *ngIf="documento.caducado && documento.tipo === 'enEspera'" class="paper">
            <img (click)="openDocumento(documento.id)" src="../../../../../assets/rojo.png" #tooltip="matTooltip"
              matTooltip="Documento nuevo rechazado" matTooltipPosition="left" />
          </div>
          <div *ngIf="documento.proximoCaduca && documento.tipo === 'enEspera'" class="paper">
            <img class="documento__circulo" (click)="openDocumento(documento.id)"
              src="../../../../../assets/Amarillo.png" #tooltip="matTooltip" matTooltip="Documento nuevo rechazado"
              matTooltipPosition="left" />
          </div>
          <p>{{documento.nombre}}</p>
          <p style="background-color: #1F775A; color: white; border-radius: 4px; padding: 0 0.2rem 0 0.2rem;">
            {{documento.nombreArchivo}}</p>
          <p>{{documento?.fechaValidez | date: 'dd/MM/yyyy'}}</p>
          <div *ngIf="documento.fechaCaducidad">
            <p>{{documento?.fechaCaducidad | date: 'dd/MM/yyyy'}}</p>
          </div>
          <div *ngIf="!documento.fechaCaducidad">
            <p>No caduca</p>
          </div>
        </div>

        <div class="displayFlexVertical botones" *ngIf="documentoSeleccionado4?.length === 0">
          <img src="../../../../../assets/documentBlanco.png" />
          <div class="nuevo">
            <button type="submit" id="contrato1" (click)="openDetails(centro.id, $event)">
              Añadir Contrato Tratamiento o Autorización de Operador Gestor 1
            </button>
          </div>
        </div>

        <div class="displayFlexVertical botones" *ngIf="documentoSeleccionado5?.length === 0">
          <img src="../../../../../assets/documentBlanco.png" />
          <div class="nuevo">
            <button type="submit" id="contrato2" (click)="openDetails(centro.id, $event)">
              Añadir Contrato Tratamiento o Autorización de Operador Gestor 2
            </button>
          </div>
        </div>
        <div class="displayFlexVertical botones" *ngIf="documentoSeleccionado6?.length === 0">
          <img src="../../../../../assets/documentBlanco.png" />
          <div class="nuevo">
            <button type="submit" id="contrato3" (click)="openDetails(centro.id, $event)">
              Añadir Contrato Tratamiento o Autorización de Operador Gestor 3
            </button>
          </div>
        </div>
      </div>
    </div>
    <div *ngIf="path === '/contratista/estado/centros' && documentosAdicVista">
      <h3>Documentos solicitados por sus clientes al Centro</h3>
      <div class="displayFlex documentosAdic">
        <div class="displayFlexVertical" *ngFor="let documento of documentosAdicVista">
          <div *ngIf="documento.fechaValidez && !documento.firsTime || documento.noCaduca && !documento.firsTime ">
            <div *ngIf="!documento.validado">
              <img (click)="openDocumentoAdic(documento.id)" src="../../../../../assets/pendiente-de-validar.svg" />
            </div>
            <div *ngIf="documento.enFecha && documento.tipo === 'activo'">
              <img (click)="openDocumentoAdic(documento.id)" src="../../../../../../assets/validado.svg"
                #tooltip="matTooltip" matTooltip="Validado" matTooltipPosition="left" />
            </div>
            <div *ngIf="documento.proximoCaduca && documento.tipo === 'activo'">
              <img (click)="openDocumentoAdic(documento.id)" src="../../../../../assets/proximo-a-caducar.svg"
                #tooltip="matTooltip" matTooltip="Próximo a caducar" matTooltipPosition="left" />
            </div>
            <div *ngIf="documento.caducado && documento.tipo === 'activo'">
              <img (click)="openDocumentoAdic(documento.id)" src="../../../../../assets/caducado.svg"
                #tooltip="matTooltip" matTooltip="Caducado" matTooltipPosition="left" />
            </div>

            <div *ngIf="documento?.noCaduca && documento?.tipo === 'activo'" class="documentos-indicadores1">
              <img (click)="openDocumentoAdic(documento.id)" src="../../../../../assets/validado.svg" #tooltip="matTooltip" matTooltip="Validado"
                matTooltipPosition="left" />
            </div>
            <div *ngIf="documento?.noCaduca && documento?.tipo === 'enEspera'" class="documentos-indicadores1">
              <img (click)="openDocumentoAdic(documento.id)" src="../../../../../assets/verde.png" #tooltip="matTooltip" matTooltip="Documento nuevo rechazado"
                matTooltipPosition="left" />
            </div>

            <div *ngIf="documento.enFecha && documento.tipo === 'enEspera'" class="paper">
              <img (click)="openDocumentoAdic(documento.id)" src="../../../../../assets/verde.png" #tooltip="matTooltip"
                matTooltip="Documento nuevo rechazado" matTooltipPosition="left" />
            </div>
            <div *ngIf="documento.caducado && documento.tipo === 'enEspera'" class="paper">
              <img (click)="openDocumentoAdic(documento.id)" src="../../../../../assets/rojo.png" #tooltip="matTooltip"
                matTooltip="Documento nuevo rechazado" matTooltipPosition="left" />
            </div>
            <div *ngIf="documento.proximoCaduca && documento.tipo === 'enEspera'" class="paper">
              <img class="documento__circulo" (click)="openDocumentoAdic(documento.id)"
                src="../../../../../assets/Amarillo.png" #tooltip="matTooltip" matTooltip="Documento nuevo rechazado"
                matTooltipPosition="left" />
            </div>
            <p>{{documento.nombre}}</p>
            <p style="background-color: #1F775A; color: white; border-radius: 4px; padding: 0 0.2rem 0 0.2rem;">
              {{documento.nombreArchivo}}</p>
            <p>{{documento?.fechaValidez | date: 'dd/MM/yyyy'}}</p>
            <div *ngIf="documento.fechaCaducidad">
              <p>{{documento?.fechaCaducidad | date: 'dd/MM/yyyy'}}</p>
            </div>
            <div *ngIf="!documento.fechaCaducidad">
              <p>No caduca</p>
            </div>
          </div>

        </div>

        <div class="displayFlexVertical botones" *ngIf="docAdicional1vista?.length === 0 && docAdicional1?.length > 0">

          <img src="../../../../../assets/documentBlanco.png" />
          <div class="nuevoAdic">
            <button type="submit" id="{{docAdicional1.periocidad}}"
              (click)="openDetailsDocAdic(centro.id, $event, docAdicional1[0])">
              Añadir<br> {{docAdicional1[0]?.nombreArchivo}}
            </button>

          </div>

        </div>

        <div class="displayFlexVertical botones" *ngIf="docAdicional2vista?.length === 0 && docAdicional2?.length > 0">

          <img src="../../../../../assets/documentBlanco.png" />
          <div class="nuevoAdic">
            <button type="submit" id="{{docAdicional2.periocidad}}"
              (click)="openDetailsDocAdic(centro.id, $event, docAdicional2[0])">
              Añadir<br> {{docAdicional2[0]?.nombreArchivo}}
            </button>

          </div>

        </div>

        <div class="displayFlexVertical botones" *ngIf="docAdicional3vista?.length === 0 && docAdicional3?.length > 0 ">

          <img src="../../../../../assets/documentBlanco.png" />
          <div class="nuevoAdic">
            <button type="submit" id="{{docAdicional3.periocidad}}"
              (click)="openDetailsDocAdic(centro.id, $event,docAdicional3[0])">
              Añadir<br> {{docAdicional3[0]?.nombreArchivo}}
            </button>

          </div>

        </div>


      </div>
    </div>

    <!-- (click)="selectGestores(matOption) -->
    <div *ngIf="path === '/contratista/estado/centros'">
      <h3>Gestores</h3>
      <div *ngIf="centro?.gestors?.length && disableInputBox; else elseBlock " class="displayFlex">
        <div *ngFor="let gestor of centro?.gestors">
          <p class="gestores">{{ gestor.nombre }}</p>
        </div>
      </div>
      <ng-container *ngIf="!disableInputBox">
        <h4>Seleccione los gestores que desea:</h4>
        <h5 style="color: rgb(80, 80, 80);">(Marcados los que ya están asignados al centro)</h5>
        <mat-form-field appearance="outline">

          <mat-label>Gestores</mat-label>
          <mat-select multiple [(value)]="selected">
            <mat-option *ngFor="let gestor of allGestores" [value]="gestor.id" #matOption
              (click)="selectGestores(matOption)">{{gestor.nombre}}</mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>
      <ng-template #elseBlock></ng-template>
    </div>
    <div *ngIf="path === '/contratista/estado/centros'">
      <h3>Transportistas</h3>
      <div *ngIf="centro?.transportistas?.length && disableInputBox; else elseBlock" class="displayFlex">
        <div *ngFor="let transportista of centro?.transportistas">
          <p class="transportistas">{{ transportista.nombre }}</p>
        </div>
      </div>
      <ng-container *ngIf="!disableInputBox">
        <h4>Seleccione los transportistas que desea:</h4>
        <h5 style="color: rgb(80, 80, 80);">(Marcados los que ya están asignados al centro)</h5>
        <mat-form-field appearance="outline">

          <mat-label>Transportistas</mat-label>
          <mat-select multiple [(value)]="selectedTransp">
            <mat-option *ngFor="let transportista of allTransportistas" [value]="transportista.id" #matOption
              (click)="selectTransportistas(matOption)">{{transportista.nombre}}</mat-option>
          </mat-select>
        </mat-form-field>
      </ng-container>
      <ng-template #elseBlock>-</ng-template>
    </div>

    <div *ngIf="path != '/contratista/estado/centros'">
      <h3>Gestores</h3>
      <div *ngIf="centro?.gestors?.length" class="displayFlex">
        <div *ngFor="let gestor of centro?.gestors">
          <p class="gestores">{{ gestor.nombre }}</p>
        </div>
      </div>
    </div>
    <div *ngIf="path !='/contratista/estado/centros'">
      <h3>Transportistas</h3>
      <div *ngIf="centro?.transportistas?.length" class="displayFlex">
        <div *ngFor="let transportista of centro?.transportistas">
          <p class="transportistas">{{ transportista.nombre }}</p>
        </div>
      </div>
    </div>

  </div>
</div>